import moment from 'moment'

import { Project, ProjectStatus } from '../interfaces/entities/project'
import { contacts as mockedContacts } from './contacts'
import { campaigns as mockedCampaigns } from './campaigns'
import { clients as mockedClients } from './clients'
import { formatsets as mockedFormatsets } from './formatsets'

export const projectStatuses: ProjectStatus[] = [
  {
    name: 'work_in_progress',
    title: 'Work in progress',
    description: 'Work in progress.',
  },
  {
    name: 'specification_finalized',
    title: 'Specification finalized',
    description: 'Specification finalized.',
  },
  {
    name: 'open',
    title: 'Open',
    description: 'Open.',
  },
  {
    name: 'project_preparation',
    title: 'Project preparation',
    description: 'Project preparation.',
  },
  {
    name: 'sent',
    title: 'Sent to agency',
    description: 'Sent to agency.',
  },
]

export const projects: Project[] = [
  {
    id: '1',
    name: 'Allianz',
    status: projectStatuses[3],
    campaigns: [mockedCampaigns[1]],
    possibleActions: [
      {
        name: 'send_to_agency',
        title: 'Send to agency',
        description:
          'Sent finalized creatives to agency for further processing',
      },
      {
        name: 'specification_request',
        title: 'Specification request',
        description: 'Open project for client login',
      },
      {
        name: 'send_creatives',
        title: 'Send creatives',
        description:
          'Sent finalized cretaives to agency for further processing',
      },
      {
        name: 'assign_and_send_tracking',
        title: 'Assign and send tracking',
        description: 'Match ClickCommands to creatives and send to publisher',
      },
      {
        name: 'edit',
        title: 'edit',
        description: '',
      },
    ],
    nextAction: {
      name: 'no_actions_required',
      title: 'No actions required',
      description: 'Currently no actions possible',
    },
    contacts: [mockedContacts[1]],
    pmContacts: [mockedContacts[2]],
    deadline: moment(1544187116282),
    client: mockedClients[0],
    comment: {
      content: 'Kampagnen geht es gut',
    },
    formatsets: mockedFormatsets,
    creativeStates: [],
    isFavorite: false,
    message: null,
  },

  {
    id: '2',
    name: 'Ha!Ribo',
    status: projectStatuses[4],
    campaigns: [],
    possibleActions: [
      {
        name: 'specification_request',
        title: 'Specification request',
        description: 'Open project for client login',
      },
    ],
    nextAction: {
      name: 'send_to_agency',
      title: 'Send to agency',
      description: 'Sent finalized cretaives to agency for further processing',
    },
    contacts: [],
    pmContacts: [],
    deadline: moment(1544187116282),
    client: mockedClients[2],
    comment: {
      content: 'Kampagnen geht es gut',
    },
    formatsets: mockedFormatsets,
    creativeStates: [],
    isFavorite: false,
    message: null,
  },
]
